import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import { toast } from 'react-toastify';

const CreateRoom = (props) =>
{
	const { open, handleClose } = props;

	const [ name, setName ] = useState('');

	useEffect(() =>
	{
		if (props.data && props.data !== null)
		{
			setName(props.data.name);
		}
		else
		{
			setName('');
		}
	}, [ props.data ]);

	const handleRoom = () =>
	{
		if (name !== '')
		{
			if (props.data !== null)
			{
				props.handleUpdate({ name: name, id: props.data?._id });
			}
			else
			{
				props.handleSave(name);
			}
		}
		else
		{
			toast.error('Please enter the Room Name');
		}
	};

	return (
		<Dialog open={open} onClose={handleClose}>
			{props.data !== null ?
				<DialogTitle>{`Update ${props.name} Conference Room`}</DialogTitle>
				: <DialogTitle>{`Create ${props.name} Conference Room`}</DialogTitle>}
			<DialogContent>
				<TextField
					autoFocus
					margin='dense'
					id='name'
					label='Room Name'
					type='email'
					fullWidth
					variant='standard'
					value={name}
					onChange={(e) => setName(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>Cancel</Button>
				{props.data !== null ?
					<Button onClick={handleRoom}>Update</Button>
					: <Button onClick={handleRoom}>Create</Button>}
			</DialogActions>
		</Dialog>
	);
};

export default CreateRoom;